import React, { useEffect } from "react";
import Header from "components/Common/Header/Header";
import AutomationScheduleChildTaskListBody from "components/AutomationComponents/AutomationScheduleListBody/AutomationScheduleChildTaskListBody";

const AutomationScheduleChildTaskList = () => {
  useEffect(() => {
    document.title = "Automation Subtask List";
  }, []);

  return (
    <main id="app">
      <Header moduleName="automation" />
      <AutomationScheduleChildTaskListBody />
    </main>
  );
};

export default AutomationScheduleChildTaskList;
